import { QueryParams } from "@/models/query-params.model";
import { QuizIndividualStudent } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, Observable, map } from "rxjs";

export class QuizService {
  private classroomId: string | undefined;

  constructor(private _stats = new StatsRest()) {
    this.classroomId = localStorage.getItem("stdClassroomId") ?? undefined;
  }

  private quiz$: BehaviorSubject<any> =
    new BehaviorSubject<QuizIndividualStudent>(new QuizIndividualStudent());
  quiz: Observable<QuizIndividualStudent> = this.quiz$.asObservable();

  getQuizStudentFromCourse(
    courseId: string,
    studentId: string,
    params: QueryParams
  ): void {
    this._stats
      .getQuizStudentFromCourse(courseId, studentId, {
        ...params,
        classroomId: this.classroomId,
      })
      .pipe(
        map((e) => {
          e.content.forEach((item) => {
            item.quizStudentStatus = this.remakeObjectStatus(
              item.quizStudentStatus
            );
            item.quizStudentPercentage =
              item.quizStudentPercentage == 0 ? 0 : item.quizStudentPercentage;
            item.quizPercentage =
              item.quizPercentage == 0 ? 0 : item.quizPercentage;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.quiz$.next(response);
        },
      });
  }
  getStatus(status: boolean): string {
    let result = "";
    if (status) {
      result = GenericsUtils.translateI18n(
        "stats.course.students.status.approved"
      );
    } else {
      result = GenericsUtils.translateI18n(
        "stats.course.students.status.failed"
      );
    }
    return result;
  }

  getStatusColor(status: string): string {
    if (status) {
      status = "bg-h-success-100 text-h-success-500";
    } else {
      status = "bg-h-error-100 text-h-error-800";
    }
    return status;
  }

  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
}
